export const isDateLessThanToday = (date: Date) => {
  const currentDate = new Date().setHours(0, 0, 0, 0);
  return new Date(date).setHours(0, 0, 0, 0) < currentDate;
};

export const isDateEqualToToday = (date: Date) => {
  const currentDate = new Date().setHours(0, 0, 0, 0)
  return new Date(date).setHours(0, 0, 0, 0) === currentDate;
};

/**
 * Epoch milliseconds for a timestamp the API sent for a UTC instant.
 *
 * The processing timestamps live in Postgres `timestamp without time zone` columns, so they come
 * back with DateTimeKind.Unspecified and Newtonsoft serializes them WITHOUT a zone suffix
 * ("2026-08-20T09:12:03"). Plain `new Date(...)` reads such a string as LOCAL time — at UTC+3 that
 * places a job which started seconds ago three hours in the future and every derived duration goes
 * negative. Strings that already carry a zone (…Z / ±hh:mm) and real Date objects are taken as-is.
 *
 * Returns undefined for a missing or unparsable value, so callers can fall back instead of
 * rendering NaN.
 */
export const parseServerDate = (value?: string | Date | null): number | undefined => {
  if (value === undefined || value === null || value === "") return undefined;

  const time =
    value instanceof Date
      ? value.getTime()
      : new Date(hasExplicitZone(value) || !hasTimeOfDay(value) ? value : `${value}Z`).getTime();

  return isFinite(time) ? time : undefined;
};

const hasExplicitZone = (value: string) => /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value);

// A date-only string ("2026-08-20") is already read as UTC by the JS spec, and appending a "Z"
// would make it unparsable — so only timestamps that carry a clock time get the suffix.
const hasTimeOfDay = (value: string) => /\d{2}:\d{2}/.test(value);
